const pt = {
  title: "Sobre o Kito",
  sections: [
    {
      heading: "Nossa missão",
      content: [
        "Transformar tempo de tela em tempo de leitura, com experiências digitais que educam, estimulam a criatividade e fortalecem o bem‑estar cognitivo.",
      ],
    },
    {
      heading: "O que é o Kito",
      content: [
        "Uma plataforma de leitura interativa com histórias inteligentes, mini livros e recursos de acessibilidade. Criamos experiências que conectam tecnologia, educação e cuidado.",
      ],
    },
    {
      heading: "Parceria Acuidar",
      content: [
        "A parceria com a Acuidar amplia o alcance do Kito e integra nossas atividades cognitivas à rotina de cuidado, promovendo estímulo mental com curadoria especializada.",
      ],
    },
    {
      heading: "Atividades cognitivas",
      content: [
        "Desafios para raciocínio lógico, atenção, memória, linguagem e percepção visomotora, com jogos como Nonograma, Desafio das Cores, Letroso e Puzzles.",
      ],
    },
    {
      heading: "Ecossistema Kito",
      content: [
        "<ul><li><strong>Kito App</strong> – Leitura interativa com múltiplos finais e narrativas personalizadas.</li><li><strong>Kito Games</strong> – Jogos educativos e desafios cognitivos (em desenvolvimento).</li></ul>",
      ],
    },
    {
      heading: "Modelo de negócio",
      content: [
        "Somos uma startup digital com foco em escala, acessibilidade e parcerias estratégicas.",
        "<ul><li><strong>Plano gratuito com anúncios</strong> para ampliar alcance.</li><li><strong>Assinatura acessível</strong> para liberar catálogo completo e recursos premium.</li><li><strong>Cobranding e parcerias</strong> para empresas, redes de cuidado e projetos editoriais.</li></ul>",
      ],
    },
    {
      heading: "Transparência e gestão",
      content: [
        "Indicadores detalhados e disponibilizados online para apoiar decisões e mensurar evolução cognitiva.",
      ],
    },
    {
      heading: "Tecnologia",
      content: [
        "<ul><li>Mobile: React Native (Android/iOS)</li><li>Backend: Node.js + Firebase</li><li>Infra: Google Cloud</li></ul>",
      ],
    },
    {
      heading: "Equipe",
      content: ["__TEAM__"],
    },
  ],
  labels: { linkedin: "LinkedIn" },
  teamProfiles: [
    {
      name: "André Lopes",
      role: "Fundador & CTO",
      image: "/images/team/andre-lopes.jpeg",
      bio: "Engenheiro de software e líder técnico, 25+ anos em produtos digitais, mobile e cloud. Foco em apps de leitura e experiências interativas.",
      linkedin: "https://www.linkedin.com/in/andrecl/",
    },
    {
      name: "Vinícius Andrade",
      role: "Desenvolvedor Frontend",
      image: "/images/team/vini-andrade.png",
      bio: "Frontend dev com experiência em React Native e UI acessível. Atua em apps educacionais e produtos consumer.",
      linkedin: "https://www.linkedin.com/in/viniacl/",
    },
  ],
};

const aboutTranslations = {
  pt,
  en: pt,
  es: pt,
};

export default aboutTranslations;
